import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@services/api/api.service';

@Component({
  selector: 'app-listing-preview-static',
  templateUrl: './listing-preview-static.component.html',
  styleUrls: ['./listing-preview-static.component.scss'],
})
export class ListingPreviewStaticComponent {
  constructor(
    private route: ActivatedRoute,
    public api: ApiService
  ) {}
  listing_preview_id: any;

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.listing_preview_id = id;
    });
    this.getListingDetails(this.listing_preview_id);
  }

  listingDetails: any;
  dayAgo: any;
  editPropertyId: any;
  trueCount: any;
  getListingDetails(id) {
    this.api.get(`/listing/full-detail/${id}?office_id=${this.api.getOfficeId()}`).subscribe({
      next: res => {
        const { status, data } = res;
        if (status) {
          this.listingDetails = data;
          const propertiesToCheck = ['isReaCrm', 'isDomainCrm', 'isWpPush', 'market_place'];
          this.trueCount = propertiesToCheck.reduce((count, property) => {
            if (this.listingDetails[property] === true) {
              return count + 1;
            }
            return count;
          }, 0);
        }
      },
    });
  }
}
